import { useContext, useMemo } from "react";
import { AuthContext, AuthContextValue } from "./AuthContext";

/**
 * Provides a method for receiving the current set of permissions as well as setting the permissions.
 * @returns A tuple containing the current permissions and a function for setting the current permissions.
 */
export function usePermissions(): [ReadonlyArray<string>, AuthContextValue["setPermissions"]] {
  const { permissions, setPermissions } = useContext(AuthContext);

  return useMemo<ReturnType<typeof usePermissions>>(() => {
    return [permissions, setPermissions];
  }, [permissions, setPermissions]);
}
